/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./depositDetail.vue?vue&type=template&id=333073d6&scoped=true"
import script from "./depositDetail.vue?vue&type=script&lang=js"
export * from "./depositDetail.vue?vue&type=script&lang=js"
import style1 from "./depositDetail.vue?vue&type=style&index=1&id=333073d6&prod&lang=scss&scoped=true"
import style2 from "./depositDetail.vue?vue&type=style&index=2&id=333073d6&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333073d6",
  null
  
)

export default component.exports